<template>
  <div class="CFEMandateList">
    <v-card flat v-if="showInitiateForm" class="py-3">
      <v-alert outlined color="warning" class="ma-4" v-if="isAgreementNotSigned()">
        Agreement not signed. Please sign an agreement to initiate an EMandate
      </v-alert>
      <component
        :ref="initiateEMandateFFormMetaData.myRefName"
        :is="initiateEMandateFFormMetaData.componentName"
        :value="selectModel(initiateEMandateInput, undefined)"
        @input="
          (newValue) => updateModel(initiateEMandateInput, newValue, undefined)
        "
        v-bind="initiateEMandateFFormMetaData.props"
      ></component>
    </v-card>

    <component
      :ref="cfeMandateListFDataTableMetaData.myRefName"
      :is="cfeMandateListFDataTableMetaData.componentName"
      :value="fiEMandateSummaryList"
      v-bind="cfeMandateListFDataTableMetaData.props"
    ></component>
  </div>
</template>

<script lang="ts">
import { Component, Prop, Watch } from "vue-property-decorator";
import ModelVue from "@/components/ModelVue";
import FForm from "@/components/form/FForm.vue";
import FDataTable from "@/components/table/FDataTable.vue";
import store, * as Store from "@/../src-gen/store";
import * as Data from "@/../src-gen/data";
import * as Action from "@/../src-gen/action";
import CFEMandateListFDataTableMDP from "./CFEMandateListFDataTableMDP";
import InitiateEMandateFFormMDP from "@/components/generic/file/eMandateList/InitiateEMandateFFormMDP";

@Component({
  components: {
    FForm,
    FDataTable,
  },
})
export default class CFEMandateList extends ModelVue {
  @Prop({ required: true })
  clientFileId: string;

  @Prop({ default: "" })
  clientFileStatus: string;

  @Prop({ default: 0 })
  collectionAmount: number;

  @Store.Getter.ClientFile.ClientFileSummary.fiEMandateSummaryList
  fiEMandateSummaryList: Data.ClientFile.FiEMandateSummary[];

  initiateEMandateInput: Data.ClientFile.InitiateEMandateInput =
    new Data.ClientFile.InitiateEMandateInput();
  showInitiateForm: boolean = false;

  mounted() {
    this.getEMandateList();
    Action.ClientFile.InitiateEMandate.interested(this.getEMandateListHandler);
  }
  destroyed() {
    Action.ClientFile.InitiateEMandate.notInterested(this.getEMandateListHandler);
  }

  public getEMandateListHandler = () => {
    setTimeout(() => {
      this.getEMandateList();
    }, 1000);
  };

  @Watch("clientFileId")
  onClientFileIdChange() {
    this.getEMandateList();
  }

  get cfeMandateListFDataTableMetaData() {
    return new CFEMandateListFDataTableMDP({ parent: this }).getMetaData();
  }

  get initiateEMandateFFormMetaData() {
    return new InitiateEMandateFFormMDP({ parent: this }).getMetaData();
  }

  getEMandateList() {
    if (!this.clientFileId) {
      return;
    }
    Action.ClientFile.GetAllEMandateList.execute1(
      this.clientFileId,
      (output) => {}
    );
  }

  prepopulateDetails() {
    this.initiateEMandateInput.collectionAmount = this.collectionAmount || 0;
    this.initiateEMandateInput.clientBankInfo.nupayBankId =
      this.fiEMandateSummaryList[0]?.nupayBankId;
    this.initiateEMandateInput.clientBankInfo.accountNumber =
      this.fiEMandateSummaryList[0]?.accountNumber;
    this.initiateEMandateInput.clientBankInfo.ifscCode =
      this.fiEMandateSummaryList[0]?.ifscCode;
    this.initiateEMandateInput.clientBankInfo.accountHolderName =
      this.fiEMandateSummaryList[0]?.accountHolderName;
  }

  initiateEMandate() {
    this.initiateEMandateInput.clientFileId = this.clientFileId;
    Action.ClientFile.InitiateEMandate.execute(
      this.initiateEMandateInput,
      (output) => {
        this.showInitiateForm = false;
        this.initiateEMandateInput = new Data.ClientFile.InitiateEMandateInput();
      }
    );
  }

  isAgreementNotSigned() {
    return this.clientFileStatus === Data.ClientFile.CLIENT_FILE_STATUS.LEAD.id;
  }
}
</script>
